import React from 'react';
import AppLayout from '../../components/Layout/AppLayout';
import styles from './AddClient.module.css'

const AddClient = () => {
  return (
    <div className="App">
      <AppLayout
        title="Add Client"
      >
        <div className={styles.container}>
          <header className={styles.header}>
            <h1>Search</h1>
          </header>
          <div className={styles.form_container}>

            <div className={styles.form}>
              <div className={styles.input}>
                <label>Name</label>
                <input type="text" name=""/>
              </div>
              <div className={styles.input}>
                <label>Company Name</label>
                <input type="text" name=""/>
              </div>
              <div className={styles.input}>
                <label>Email</label>
                <input type="text" name=""/>
              </div>
              <div className={styles.input}>
                <label>Address</label>
                <input type="text" name=""/>
              </div>
              <div className={styles.input}>
                <label>Contact</label>
                <input type="text" name=""/>
              </div>
              <div className={styles.input}>
                <label>Status</label>
                <input type="text" name=""/>
              </div>
              <div className={styles.input}>
                <label>Date From</label>
                <input type="date" name="" id=""/>
              </div>
              <div className={styles.input}>
                <label>Date to</label>
                <input type="date" name="" id=""/>
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button>Submit</button>
              <button>Clear</button>
            </div>

          </div>
        </div>

      </AppLayout>
    </div>
  );
}

export default AddClient;
